/**
 * IOT-HAL-1: HAL EventBus event name constants.
 *
 * All exports are type-only (const object). No runtime logic.
 * Consumers subscribe via EventBusService — no direct adapter imports.
 * Full payload schemas documented in docs/iot/IOT-HAL-1-event-contract.md.
 */

export const HAL_EVENTS = {
  DEVICE_REGISTERED:         'iot.device.registered',
  DEVICE_LIFECYCLE_CHANGED:  'iot.device.lifecycle_changed',
  TELEMETRY_RECEIVED:        'iot.telemetry.received',
  EVENT_RECEIVED:            'iot.event.received',
  CONFIG_PUSH_INITIATED:     'iot.config.push_initiated',
  CONFIG_PUSH_ACKNOWLEDGED:  'iot.config.push_acknowledged',
  CONFIG_PUSH_APPLIED:       'iot.config.push_applied',
  CONFIG_PUSH_FAILED:        'iot.config.push_failed',
  HEALTH_DEGRADED:           'iot.health.degraded',
  HEALTH_RESTORED:           'iot.health.restored',
  // IOT-AGENTIC-CONFIG-SUBSTRATE-1: agentic config push lifecycle
  CONFIG_PUSH_PROPOSED:      'iot.config.push_proposed',   // pre-gate: receipt written, confidence check pending
  CONFIG_PUSH_REJECTED:      'iot.config.push_rejected',   // human explicitly rejected an AEGIS proposal
  CONFIG_PUSH_ABSTAINED:     'iot.config.push_abstained',  // agent abstained (confidence below floor)
} as const;

export type HalEventName = typeof HAL_EVENTS[keyof typeof HAL_EVENTS];
